module.exports = __webpack_public_path__ + "static/img/icon_fzzx.a82c9db6.png";